(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7086],{

/***/ 49880:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/u/[username]/answer/[[...status]]",
      function () {
        return __webpack_require__(67360);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 67360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ ProfileAnswerPage; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_community_website_community_website_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_runner_work_community_website_community_website_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_community_website_community_website_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_infinite_scroll_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58533);
/* harmony import */ var _common_styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82012);
/* harmony import */ var _components_Tab__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90568);
/* harmony import */ var _components_ProfileLayout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78468);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(18963);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(41080);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(27049);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(95507);
/* harmony import */ var _components_ListItem__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53662);
/* harmony import */ var _api_asktug_profile__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21049);
/* harmony import */ var _utils_datetime_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11093);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _components_EmptyStatus__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(48556);
/* harmony import */ var _pages_u_username_constant_data__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(48956);
/* harmony import */ var swr_infinite__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(44593);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(89590);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8100);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(21679);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



// import { useRouter } from 'next/router';


// import * as Styled from './index.styled';

// import { getPageQuery } from '~/utils/pagination.utils';














var pageSize = 20;
var __N_SSP = true;
function ProfileAnswerPage(props) {
    var ref, ref1, ref2, ref3;
    var badgesFromSSR = props.badges, profileFromSSR = props.profile, summaryFromSSR = props.summary, answersFromSSR = props.answers, postsNumberFromSSR = props.postsNumber, postFavoritesNumberFromSSR = props.postFavoritesNumber;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)();
    var _query = router.query, status = _query.status, username = _query.username;
    var ref4;
    var statusPathInfo = (ref4 = status === null || status === void 0 ? void 0 : status[0]) !== null && ref4 !== void 0 ? ref4 : "";
    var markedSolution = (status === null || status === void 0 ? void 0 : status[0]) === "solution";
    var fallbackData = [
        answersFromSSR
    ];
    var ref5 = (0,swr_infinite__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(function(pageNumber) {
        return [
            "asktug.profile.getAnswersByUsername",
            {
                pageNumber: pageNumber + 1,
                pageSize: pageSize,
                username: username,
                markedSolution: markedSolution
            }, 
        ];
    }, {
        fetcher: _api__WEBPACK_IMPORTED_MODULE_13__/* .fetcher */ ._i,
        fallbackData: fallbackData
    }), data = ref5.data, error = ref5.error, setSize = ref5.setSize, mutate = ref5.mutate;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        mutate(function() {
            return [
                []
            ];
        }, false).then();
    }, [
        mutate,
        markedSolution
    ]);
    // use swr infinite holds all the resp lists
    var answers = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var _result;
        var result = [];
        data === null || data === void 0 ? void 0 : data.flatMap(function(value) {
            return (_result = result).push.apply(_result, _toConsumableArray(value));
        });
        return result;
    }, [
        data
    ]);
    var loadMoreData = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(_asyncToGenerator(_home_runner_work_community_website_community_website_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _home_runner_work_community_website_community_website_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return setSize(function(size) {
                        return size + 1;
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        setSize
    ]);
    var isLoading = !data && !error;
    var hasMore = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        // if not loaded, has more
        if (!data) {
            return true;
        }
        return data[data.length - 1].length >= pageSize;
    }, [
        data
    ]);
    var ref6 = (0,swr__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)([
        "asktug.profile.getUserProfileByUsername",
        {
            username: username
        }
    ], {
        fallbackData: profileFromSSR
    }), profileData = ref6.data, profileError = ref6.error;
    if (profileError) console.error("profileError", profileError);
    var ref7 = (0,swr__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)([
        "asktug.profile.getBadgesByUsername",
        {
            username: username
        }
    ], {
        fallbackData: badgesFromSSR
    }), badgesData = ref7.data, badgesError = ref7.error;
    if (badgesError) console.error("badgesError", badgesError);
    var ref8 = (0,swr__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)([
        "blog.getPostFavoritesNumberByUsername",
        {
            username: username
        }
    ], {
        fallbackData: postFavoritesNumberFromSSR
    }), postFavoritesNumberData = ref8.data, postFavoritesNumberError = ref8.error;
    if (postFavoritesNumberError) console.error("postFavoritesNumberError", postFavoritesNumberError);
    var postFavoritesNumber = postFavoritesNumberError ? null : postFavoritesNumberData;
    var ref9 = (0,swr__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)([
        "asktug.profile.getSummaryByUsername",
        {
            username: username
        }
    ], {
        fallbackData: summaryFromSSR
    }), summaryData = ref9.data, summaryError = ref9.error;
    if (summaryError) console.error("summaryError", summaryError);
    var ref10;
    var askTugFavoritesNumber = summaryError ? null : (ref10 = summaryData === null || summaryData === void 0 ? void 0 : (ref = summaryData.user_summary) === null || ref === void 0 ? void 0 : ref.bookmark_count) !== null && ref10 !== void 0 ? ref10 : 0;
    var allFavoritesNumber = summaryError ? null : askTugFavoritesNumber + (postFavoritesNumber !== null && postFavoritesNumber !== void 0 ? postFavoritesNumber : 0);
    var ref11;
    var likeNumber = (ref11 = summaryData === null || summaryData === void 0 ? void 0 : (ref1 = summaryData.user_summary) === null || ref1 === void 0 ? void 0 : ref1.likes_received) !== null && ref11 !== void 0 ? ref11 : null;
    var ref12;
    var answerNumber = (ref12 = summaryData === null || summaryData === void 0 ? void 0 : (ref2 = summaryData.user_summary) === null || ref2 === void 0 ? void 0 : ref2.post_count) !== null && ref12 !== void 0 ? ref12 : null;
    var ref13;
    var questionNumber = (ref13 = summaryData === null || summaryData === void 0 ? void 0 : (ref3 = summaryData.user_summary) === null || ref3 === void 0 ? void 0 : ref3.topic_count) !== null && ref13 !== void 0 ? ref13 : null;
    var ref14 = (0,swr__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)([
        "blog.getPostsNumberByUsername",
        {
            username: username
        }
    ], {
        fallbackData: postsNumberFromSSR
    }), postsNumberData = ref14.data, postsNumberError = ref14.error;
    if (postsNumberError) console.error("postsNumberError", postsNumberError);
    var postsNumber = postsNumberData;
    if (profileData === null) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_15__/* .ErrorPage */ .mf, {
            statusCode: 404,
            errorMsg: "\u7528\u6237 ".concat(username, " \u4E0D\u5B58\u5728")
        });
    }
    var isEmpty = !isLoading && answers.length === 0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_ProfileLayout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        badges: badgesData,
        profile: profileData,
        nums: {
            like: likeNumber,
            answer: answerNumber,
            post: postsNumber
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_common_styled__WEBPACK_IMPORTED_MODULE_4__/* .Action */ .aU, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Tab__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        selected: _components_Tab__WEBPACK_IMPORTED_MODULE_5__/* .EUgcType.answer */ .$.answer,
                        nums: {
                            answer: answerNumber,
                            question: questionNumber,
                            post: postsNumber,
                            favorite: allFavoritesNumber
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                        defaultValue: statusPathInfo,
                        value: statusPathInfo,
                        onChange: function(value) {
                            return router.push("/u/".concat(encodeURIComponent(username), "/answer/").concat(value), undefined, {
                                shallow: true
                            });
                        },
                        style: {
                            width: _common_styled__WEBPACK_IMPORTED_MODULE_4__/* .filterSelectWidth */ .KN
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_16__/* ["default"].Option */ .Z.Option, {
                                value: "",
                                children: "\u5168\u90E8"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_16__/* ["default"].Option */ .Z.Option, {
                                value: "solution",
                                children: "\u88AB\u6807\u8BB0\u4E3A\u89E3\u51B3\u65B9\u6848"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_common_styled__WEBPACK_IMPORTED_MODULE_4__/* .List */ .aV, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_infinite_scroll_component__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    dataLength: answers.length,
                    next: loadMoreData,
                    hasMore: hasMore,
                    loader: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        style: {
                            marginTop: "16px"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                            avatar: true,
                            paragraph: {
                                rows: 1
                            },
                            active: true
                        })
                    }),
                    endMessage: answers.length !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        plain: true,
                        children: "\u6CA1\u6709\u66F4\u591A\u5185\u5BB9\u4E86"
                    }),
                    children: isEmpty ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_EmptyStatus__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        description: "\u4F60\u8FD8\u6CA1\u6709\u56DE\u7B54\u8FC7\u4EFB\u4F55\u95EE\u9898",
                        children: [
                            "\u5FEB\u524D\u5F80 ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                href: _pages_u_username_constant_data__WEBPACK_IMPORTED_MODULE_19__/* .forumUrl */ .s,
                                children: "\u3010\u95EE\u7B54\u8BBA\u575B\u3011"
                            }),
                            " \u7B54\u7591\u89E3\u60D1\u5427\uFF5E"
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                        dataSource: answers,
                        //loading={loading}
                        locale: {
                            emptyText: "\u6682\u65E0\u6570\u636E"
                        },
                        renderItem: function(value) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_ListItem__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                url: (0,_api_asktug_profile__WEBPACK_IMPORTED_MODULE_8__.getTopicUrl)(value.topic_id, value.post_number),
                                title: value.title,
                                summary: value.excerpt,
                                metadataEnd: (0,_utils_datetime_utils__WEBPACK_IMPORTED_MODULE_9__/* .getRelativeDatetime */ .o)(value.created_at)
                            }, value.post_id);
                        }
                    })
                })
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7427,4472,2458,9774,2888,179], function() { return __webpack_exec__(49880); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);